import React, { FC } from "react";
import { IconButton as MuiIconButton } from "@mui/material";

type Props = React.ComponentProps<typeof MuiIconButton>;

const IconButton: FC<Props> = (props) => {
    return <MuiIconButton {...props}/>
}

export default IconButton;